import { createRoute } from "@tanstack/react-router";
import { z } from "zod";

import { brandRoute } from "../../platform/routes";
import { TemplatesScreen } from "./TemplatesScreen";

// `?tab=`: the page's tab, live's `library` (the default) or `my-generations`. Anything else is
// the Library, as live's. `?template=`: a template whose preview shows until it closes (the Pro Studio
// redesign's Templates page links here, spec ui-perf/pro-studio-redesign decision 28); a
// malformed id is dropped.
const templatesSearch = z.object({
  tab: z.enum(["library", "my-generations"]).optional().catch(undefined),
  template: z
    .string()
    .max(64)
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)
    .optional()
    .catch(undefined),
});

/**
 * Live's Templates page (`/app/templates`, spec G14-templates): the cards are everyone's, a run
 * is a brand's, so it hangs under the brand.
 */
export const templatesRoute = createRoute({
  getParentRoute: () => brandRoute,
  path: "templates",
  validateSearch: (search) => templatesSearch.parse(search),
  component: TemplatesScreen,
});
